var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000a3c;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,0C89.54,0,0,89.54,0,200s89.54,200,200,200,200-89.54,200-200S310.46,0,200,0Zm120.54,248.53c-3.83,28.74-18.2,33.05-46.46,35.44-24.43,2.39-52.21,2.87-73.76,2.87s-49.81-.48-73.76-2.87c-28.26-2.39-43.11-6.71-46.94-35.44-1.44-12.45-2.39-30.65-2.39-48.85s.96-35.92,2.39-48.85c3.83-28.26,18.68-33.05,46.94-35.44,23.95-1.92,52.21-2.87,73.76-2.87s49.33,.96,73.76,2.87c28.26,2.39,42.63,7.18,46.46,35.44,1.92,12.93,2.87,30.65,2.87,48.85s-.96,36.4-2.87,48.85Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175.42 162.8 239.6 199.68 175.42 237.04 175.42 162.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.37e840974fa725e8f168f6748d296e5f.svg";
export { ForwardRef as ReactComponent };